/*! @pentacode/ui v0.1.0 */
import { r as e } from "../../scene-8VKOJsMP.js";
import { t } from "../../mark-decorative-B0-tbEeT.js";
import { i as n, n as r, r as i, t as a } from "../../polar-DGg71UsL.js";
import { i as o, n as s, p as c, t as l } from "../../shared-CfvkKPnq.js";
import { formatCurrency as u, formatPercent as d } from "../format.js";
import { r as f, t as p } from "../../theme-BDdgxk0M.js";
import { savingsColors as m } from "./savings.js";
// src/charts/presets/return.ts
function h({ savings: e, fees: t }) {
	return t > 0 ? (e - t) / t : void 0;
}
function g({ savings: e, fees: t }) {
	return e >= t ? [{
		label: "Gebühren",
		value: t,
		color: m.Gebühren
	}, {
		label: "Netto-Ersparnis",
		value: e - t,
		color: p.positive
	}] : [{
		label: "Ersparnis",
		value: e,
		color: p.positive
	}, {
		label: "Ungedeckte Gebühren",
		value: t - e,
		color: p.negative
	}];
}
function _(p) {
	let m = g(p).filter((e) => e.value > 0), _ = m.reduce((e, t) => e + t.value, 0), v = h(p), y = (e, t, n, r) => i([{ id: e }], {
		angle: 0,
		radius: 0,
		text: () => e,
		key: "id",
		fill: "currentColor",
		dy: t,
		fontSize: n,
		fontWeight: r
	}), b = {
		inset: 8,
		radiusRatio: .9
	};
	return e({
		theme: f,
		marks: [a({
			...b,
			scales: {
				angle: null,
				radius: null
			},
			marks: [r(n(m, { value: "value" }), {
				innerRadius: ({ radius: e }) => e * .78,
				cornerRadius: 3,
				padAngle: () => .01,
				color: "label",
				key: "label"
			})]
		}), t(a({
			...b,
			scales: {
				angle: { scale: c().domain([0, 1]) },
				radius: { scale: c().domain([0, 1]) }
			},
			marks: [y(v === void 0 ? "–" : d(v), -6, 24, 700), y("Rendite", 16, 13, 400)]
		}))],
		scales: {
			x: null,
			y: null
		},
		color: o(m.map((e) => e.label), l(m), !1),
		tooltip: s(u, _)
	});
}
export { _ as returnChart, g as returnItems, h as savingsReturn };

//# sourceMappingURL=return.js.map